import { render, staticRenderFns } from "./SwipeIcon.vue?vue&type=template&id=76d1b30e&"
import script from "./SwipeIcon.vue?vue&type=script&lang=ts&"
export * from "./SwipeIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports